/* eslint-disable react-hooks/rules-of-hooks */
import { Operator } from '@jexop/core';
import { isString } from 'lodash';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { Nullable } from '../types';

type Callback = () => void;

export const routeFunction: Operator = (props): Nullable<Callback> => {
  const navigate = useNavigate();
  const { route, ...rest } = props;
  const state = rest as NavigateOptions || {};

  if (!isString(route)) {
    return null;
  }

  return () => {
    navigate(route, { state });
  };
};
